module.exports = __webpack_public_path__ + "media/images/menu/btn-menu-mobile-9a12b3e54eacc32c832b2f67a2cb6702.png";